/**
 * Copyright © 2026 Adnuntius AS.
 *
 * Cycle-safe DI tokens for session profile services. Import these instead of
 * LocalUserProfile / LocalNetworkProfile from network resources and AdnLogService
 * — those create ES-module cycles with the profile classes.
 */
import {InjectionToken} from '@angular/core';
import type {NetworkApiService} from '../../app/admin/network/network-api.service';
import type {NetworkProfileApiService} from './network-profile-api.service';

export const LOCAL_USER_PROFILE = new InjectionToken<any>('LocalUserProfile');
export const LOCAL_NETWORK_PROFILE = new InjectionToken<any>('LocalNetworkProfile');
export const NETWORK_API = new InjectionToken<NetworkApiService>('NetworkApi');
export const NETWORK_PROFILE_API = new InjectionToken<NetworkProfileApiService>('NetworkProfileApi');
